<template>
    <rkm-area
        v-if="verificarPermissao('updateAll-ambulatorio-jornada') "
        background-color="primary"
        closed
        no-margin-top
        title="Edição de jornadas selecionadas"
        type="box"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="form.infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.lotacoes"
                        :validations="validations.lotacao"
                        @change="handleLotacaoChange"
                        label="CBO"
                        show-default-option
                        text-field="ocupacaoDescricao"
                        v-model="model.lotacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.especialidades"
                        :validations="validations.especialidade"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="model.especialidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.tipos"
                        :validations="validations.tipo"
                        label="Tipo"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.situacoes"
                        :validations="validations.situacao"
                        @change="handleSituacaoChange"
                        label="Situação"
                        show-default-option
                        text-field="nome"
                        v-model="model.situacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :validations="validations.inicio"
                        label="Hora inicial"
                        v-model="model.inicio"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :disabled="!model.situacaoId"
                        :validations="validations.fim"
                        label="Hora final"
                        v-model="model.fim"
                    />
                </rkm-col>

                <rkm-col colas="3">
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.quantidadeConsulta"
                        label="Quantidade de consultas"
                        number
                        v-model="model.quantidadeConsulta"
                    />
                </rkm-col>

                <rkm-col colas="3">
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.tempoConsulta"
                        append="Minuto(s)"
                        label="Tempo da consulta"
                        number
                        v-model="model.tempoConsulta"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.quantidadeRetorno"
                        label="Quantidade de retornos"
                        number
                        v-model="model.quantidadeRetorno"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.tempoRetorno"
                        append="Minuto(s)"
                        label="Tempo do retorno"
                        number
                        v-model="model.tempoRetorno"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :validations="validations.permiteAgendamentoSomenteSupervisor"
                        label="Permitir agendamento apenas para o supervisor"
                        show-default-option
                        v-model="model.permiteAgendamentoSomenteSupervisor"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :validations="validations.tipoAgendamentoSafecare"
                        label="Agendamento Aplicativo"
                        show-default-option
                        v-model="model.tipoAgendamentoSafecare"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :disabled="!jornadas.find(jornada => jornada.selecionada === true)"
                        :label="false"
                        @click="update"
                        color="primary"
                    >
                        Atribuir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-area>
</template>

<script>
// Mixins.
import {error, formats, permissao, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        unidadeIsRequired() {
            return !this.model.infraestruturaId &&
                !this.model.lotacaoId &&
                !this.model.especialidadeId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        infraestruturaIsRequired() {
            return this.model.unidadeId || (
                !this.model.lotacaoId &&
                !this.model.especialidadeId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
            )
        },
        lotacaoIsRequired() {
            return this.model.infraestruturaId || (
                !this.model.especialidadeId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
            )
        },
        especialidadeIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        tipoIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        situacaoIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        inicioIsRequired() {
            return !!this.model.situacaoId || (
                !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
            )
        },
        fimIsRequired() {
            return !!this.model.situacaoId
        },
        quantidadeConsultaIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeRetorno &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        tempoConsultaIsRequired() {
            return !!this.model.quantidadeConsulta
        },
        quantidadeRetornoIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                this.model.permiteAgendamentoSomenteSupervisor === null &&
                this.model.tipoAgendamentoSafecare === null
        },
        tempoRetornoIsRequired() {
            return !!this.model.quantidadeRetorno
        },
        permiteAgendamentoSomenteSupervisorIsRequired() {
            return !this.model.lotacaoId &&
                !this.model.tipoId &&
                !this.model.situacaoId &&
                !this.model.inicio &&
                !this.model.fim &&
                !this.model.quantidadeConsulta &&
                !this.model.quantidadeRetorno
        },
        permiteTipoAgendamentoSafecareIsRequired() {
            return (
                !this.model.lotacaoId ||
                !this.model.tipoId ||
                !this.model.situacaoId ||
                !this.model.inicio ||
                !this.model.fim ||
                !this.model.quantidadeConsulta ||
                !this.model.quantidadeRetorno
            ) && !this.model.tipoAgendamentoSafecare
        },
        validations() {
            return {
                unidade: {required: this.unidadeIsRequired},
                infraestrutura: {required: this.infraestruturaIsRequired},
                lotacao: {required: this.lotacaoIsRequired},
                especialidade: {required: this.especialidadeIsRequired},
                tipo: {required: this.tipoIsRequired},
                situacao: {required: this.situacaoIsRequired},
                inicio: {
                    required: this.inicioIsRequired,
                    max_hour: this.model.situacaoId && this.model.fim ? this.formatTime(this.model.fim) : null,
                },
                fim: {
                    required: this.fimIsRequired,
                    min_hour: this.model.inicio ? this.formatTime(this.model.inicio) : null,
                },
                quantidadeConsulta: {required: this.quantidadeConsultaIsRequired},
                tempoConsulta: {required: this.tempoConsultaIsRequired},
                quantidadeRetorno: {required: this.quantidadeRetornoIsRequired},
                tempoRetorno: {required: this.tempoRetornoIsRequired},
                permiteAgendamentoSomenteSupervisor: {required: this.permiteAgendamentoSomenteSupervisorIsRequired},
                tipoAgendamentoSafecare: {required: this.permiteTipoAgendamentoSafecareIsRequired},
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.lotacoes = []
            this.form.especialidades = []
            this.model.infraestruturaId = null
            this.model.lotacaoId = null
            this.model.especialidadeId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.lotacoes = []
            this.form.especialidades = []
            this.model.lotacaoId = null
            this.model.especialidadeId = null

            if (value === null) return

            this.getLotacoes(value)
        },
        handleLotacaoChange(value) {
            this.form.especialidades = []
            this.model.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(value)
        },
        handleSituacaoChange() {
            this.model.fim = null
            this.model.quantidadeConsulta = null
            this.model.tempoConsulta = null
            this.model.quantidadeRetorno = null
            this.model.tempoRetorno = null
        },
        update() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const jornadas = []

                    this.jornadas
                        .filter(jornada => jornada.selecionada)
                        .forEach(jornada => {
                            jornadas.push({
                                id: jornada.id,
                                lotacaoId: this.model.lotacaoId ? this.model.lotacaoId : jornada.lotacaoId,
                                especialidadeId: this.model.especialidadeId ? this.model.especialidadeId : jornada.especialidadeId,
                                tipoId: this.model.tipoId ? this.model.tipoId : jornada.tipoId,
                                inicio: this.formatTime(this.model.inicio ? this.model.inicio : jornada.inicio),
                                fim: this.model.situacaoId && this.formatTime(this.model.fim ? this.model.fim : jornada.fim),
                                situacaoId: this.model.situacaoId ? this.model.situacaoId : jornada.situacaoId,
                                quantidadeConsulta: this.model.quantidadeConsulta ? this.model.quantidadeConsulta : jornada.quantidadeConsulta,
                                tempoConsulta: this.model.tempoConsulta ? this.model.tempoConsulta : jornada.tempoConsulta,
                                quantidadeRetorno: this.model.quantidadeRetorno ? this.model.quantidadeRetorno : jornada.quantidadeRetorno,
                                tempoRetorno: this.model.tempoRetorno ? this.model.tempoRetorno : jornada.tempoRetorno,
                                permiteAgendamentoSomenteSupervisor: this.model.permiteAgendamentoSomenteSupervisor ? this.model.permiteAgendamentoSomenteSupervisor : jornada.permiteAgendamentoSomenteSupervisor,
                                tipoAgendamentoSafecare: this.model.tipoAgendamentoSafecare,
                            })
                        })

                    this.setLoading()

                    this.repositories.jornada.updateAll(this.camelObjectKeysToSnakeRecursive(jornadas))
                        .then(response => {
                            let warning = ''

                            this.resetForm()

                            if (response.data.jornadasComAgendamento.length > 0) {
                                let message = ''

                                this.jornadas
                                    .filter(jornada => response.data.jornadasComAgendamento
                                        .find(jornadaComAgendamento => jornadaComAgendamento.id === jornada.id)
                                    )
                                    .forEach(jornada => {
                                        message = message + `<li>
                                            Dia ${jornada.data} - ${jornada.diaSemana},
                                            das ${jornada.inicio}
                                            às ${jornada.fim}
                                        </li>`
                                    })

                                warning = warning + `
                                    Jornada(s) com agendamento(s):
                                    <ul>${message}</ul>
                                `
                            }

                            if (response.data.jornadasConflitantes.length > 0) {
                                let message = ''

                                this.jornadas
                                    .filter(jornada => response.data.jornadasConflitantes
                                        .find(jornadaConflitante => jornadaConflitante.id === jornada.id)
                                    )
                                    .forEach(jornada => {
                                        message = message + `<li>
                                            Dia ${jornada.data} - ${jornada.diaSemana},
                                            das ${jornada.inicio}
                                            às ${jornada.fim}
                                        </li>`
                                    })

                                warning = warning + `
                                    Jornada(s) conflitante(s):
                                    <ul>${message}</ul>
                                `
                            }

                            if (warning) {
                                this.showWarningNotification(warning)
                            } else {
                                this.showSaveNotification()
                            }

                            this.$emit('updated', response.data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'infraestruturas',
                usuarioId: this.usuarioId,
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = response.data

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getLotacoes(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getLotacoes(infraestruturaId) {
            const request = {
                origem: 'cadastro',
                listar: 'lotacoes',
                usuarioId: this.usuarioId,
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.lotacoes = response.data

                if (this.form.lotacoes.length === 1) {
                    const selected = this.form.lotacoes[0]
                    this.model.lotacaoId = selected.id

                    this.getEspecialidades(this.model.lotacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(lotacaoId) {
            const request = {
                origem: 'cadastro',
                listar: 'especialidades',
                usuarioId: this.usuarioId,
                lotacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.especialidades = response.data

                if (this.form.especialidades.length === 1) {
                    const selected = this.form.especialidades[0]
                    this.model.especialidadeId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.form.infraestruturas = []
            this.form.lotacoes = []
            this.form.especialidades = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.lotacaoId = null
            this.model.especialidadeId = null
            this.model.tipoId = null
            this.model.inicio = null
            this.model.fim = null
            this.model.quantidadeConsulta = null
            this.model.tempoConsulta = null
            this.model.quantidadeRetorno = null
            this.model.tempoRetorno = null
            this.model.tipoAgendamentoSafecare = null

            this.$refs.RkmForm.resetValidator()
        },
    },
    mixins: [error, formats, permissao, repository, stringCase],
    props: {
        form: {type: Object, required: true},
        jornadas: {type: Array, required: true},
        model: {type: Object, required: true},
        usuarioId: {type: [Number, String], required: true},
    },
}
</script>